export default {
  name: "editor-button",
  props: ["btnText", "canClick", "iconClass"],
  components: {},
  data() {
    return {}
  },
  methods: {}
}
